<template>
  <div class="flex items-center justify-center" :title="statusLabel">
    <FontAwesomeIcon
      :icon="['fas', iconName]"
      :style="{ color: iconColor, fontSize: '18px' }"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'CC_Status_Icon',
  components: {
    FontAwesomeIcon
  },
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  computed: {
    status() {
      return this.params.data?.status || ''
    },
    statusLabel() {
      return this.status ? this.status.charAt(0).toUpperCase() + this.status.slice(1) : ''
    },
    statusConfig() {
      const configs = {
        'active': { icon: 'bell', color: '#DC2626' },           // Red
        'acknowledged': { icon: 'eye', color: '#2563EB' },      // Blue
        'resolved': { icon: 'circle-check', color: '#16A34A' }, // Green
        'snoozed': { icon: 'clock', color: '#EA580C' },         // Orange
        'erroneous': { icon: 'exclamation-triangle', color: '#6B7280' }, // Gray
        'expired': { icon: 'ban', color: '#9CA3AF' }            // Light gray
      }
      return configs[this.status] || { icon: 'question-circle', color: '#6B7280' }
    },
    iconName() {
      return this.statusConfig.icon
    },
    iconColor() {
      return this.statusConfig.color
    }
  }
}
</script>
